















































































































import {Component, Mixins} from 'vue-property-decorator';
import NoticeBox from '@/components/claim/popup/NoticeBox.vue'
import ClaimProduct from '@/components/claim/popup/ClaimProduct.vue'
import ClaimInformation from '@/components/claim/popup/ClaimInformation.vue'
import ProductAmountDetail from '@/components/claim/popup/ProductAmountDetail.vue'
import DiscountAndDeliveryRecalculate from '@/components/claim/popup/DiscountAndDeliveryRecalculate.vue'
import ReleaseProduct from '@/components/claim/popup/ExchangePopup/ReleaseProduct.vue'
import ProductAmount from '@/components/claim/popup/ExchangePopup/ProductAmount.vue'
import BenefitRecalculate from '@/components/claim/popup/BenefitRecalculate.vue'
import ReturnWithdrawReason from '@/components/claim/popup/ReturnWithdrawReason.vue'
import PopupBasic from '@/components/claim/popup/mixins/PopupBasic';
import ReturnExchangeDeliveryAmount from '@/components/claim/popup/ExchangePopup/ReturnExchangeDeliveryAmount.vue';
import ExchangeProcessAmount from '@/components/claim/popup/ExchangePopup/ExchangeProcessAmount.vue';
import NaverPayReturnHold from '@/components/claim/popup/NaverPayReturnHold.vue';
import NaverPayAmountDetail from '@/components/claim/popup/NaverPayAmountDetail.vue';
import {
  isCancelExchange,
  isReturnExchange,
  isExchangeRequest,
  isExchangeRejectRequest,
  isExchangeProcBeforeReceive,
  isExchangeProcWaitingRefund,
  isExchangeProcRequestRefund,
  isExchangeProcWaiting,
  isExchangeProcRequestPay
} from '@/components/claim/popup/validations';
import {ClaimClassType} from '@/types/claim';
import {BankAccount, RefundType} from 'supporter';
import {ncpPopup} from '@/utils/ncp';

interface ExchangeFormData {
  refundType: RefundType | null,
  returnWayType: string | null,
  returnDelivery: {
    invoiceNo: string | null,
    deliveryCompanyType: string | null,
    evadesReturnProcess: boolean,
  },
  refundBankAccount: BankAccount,
  additionalPayBankAccount: BankAccount,
  additionalPayRemitter: string,
}

@Component({
  components: {
    ExchangeProcessAmount,
    ReturnExchangeDeliveryAmount,
    NoticeBox,
    ClaimProduct,
    ProductAmountDetail,
    DiscountAndDeliveryRecalculate,
    ReleaseProduct,
    ProductAmount,
    BenefitRecalculate,
    ClaimInformation,
    ReturnWithdrawReason,
    NaverPayReturnHold,
    NaverPayAmountDetail
  },
  computed: {
    isCancelExchange,
    isReturnExchange,
    isExchangeRequest,
    isExchangeRejectRequest,
    isExchangeProcWaitingRefund,
    isExchangeProcBeforeReceive,
    isExchangeProcRequestRefund,
    isExchangeProcWaiting,
    isExchangeProcRequestPay,
    isNaverPayClaim(): boolean{
      return this.claimNoResponseData.originalPayType === 'NAVER_PAY'
    },
    hasWitdhrawReason(){
      return this.claimNoResponseData.withdrawReason !== null
    },
    showClaimInformation(){
      return this.isReturnExchange && (!this.isExchangeProcWaitingRefund)
    },
    showNaverPayAmountDetail(){
      return this.isNaverPayClaim && !!this.claimNoResponseData.externalData?.naver;
    },
    showNaverPayWithHoldButton(): boolean{
      if(!this.isNaverPayClaim){
        return false;
      }

      return !this.isModifyMode && this.isExchangeProcWaiting;
    },
    showNaverPayWithHoldCancelButton(): boolean{
      if(!this.isNaverPayClaim){
        return false;
      }

      return !this.isModifyMode && this.isExchangeProcWaiting;
    },
  }
})
export default class ExchangePopup extends Mixins(PopupBasic){
  private claimNo = String(this.$route.query.claimNo)
  private showNaverPayHoldPopup = false;
  private formData: ExchangeFormData = {
    refundType: this.claimNoResponseData.displayRefundType?.refundType,
    returnWayType: this.claimNoResponseData.returnWayType,
    returnDelivery: {
      invoiceNo: '',
      deliveryCompanyType: '',
      evadesReturnProcess: false,
    },
    additionalPayRemitter: this.claimNoResponseData.additionalPayRemitter,
    additionalPayBankAccount: {...this.claimNoResponseData.additionalPayBankAccount},
    refundBankAccount: {...this.claimNoResponseData.refundBankAccount},
  }

  // 입금확인
  onConfirmDeposit(): void{
    if(!this.validation('deposit')){
      return
    }

    if(!confirm(this.$t('CLAIM_POPUP_ASK_CONFIRM_DEPOSIT_MESSAGE').toString())){
      return
    }

    const {additionalPayBankAccount, additionalPayRemitter} = this.formData
    const request : any = {
      pathParams: {
        no: this.claimNo
      },
      data: {
        additionalPayBankAccount,
        additionalPayRemitter
      }
    }

    const confirmApi = {
      [ClaimClassType.CANCEL_EXCHANGE]: () => this.$api.putCancelExchangesNoCongirmDeposit(request),
      [ClaimClassType.RETURN_EXCHANGE]: () => this.$api.putReturnExchangesNoConfirmDeposit(request)
    }

    confirmApi[this.claimNoResponseData.claimClassType]()
      .then(()=>{
        alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
        this.onClickClose()
        this.reload()
    })
  }

  // 취소,반품 교환 신청 철회(반려)
  private async onWithdraw(): Promise<void>{
    const confirmMessage = await this.checkAmountChangeAndGetConfirmMessage()
    if(!confirm(this.$t(confirmMessage).toString())){
      return
    }

    const request = {
      pathParams: {
        no: this.claimNo
      }
    }

    const withdrawApi = {
      [ClaimClassType.CANCEL_EXCHANGE]: () => this.$api.putCancelExchangesNoWithdraw(request),
      [ClaimClassType.RETURN_EXCHANGE]: () => this.$api.putReturnExchangesNoWithdraw(request)
    }

    try{
      await withdrawApi[this.claimNoResponseData.claimClassType]()
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
      this.onClickClose()
      this.reload()
    }catch(e){

    }
  }

  /*
  * 반품교환 철회(반려?) 승인
  * 반품 교환은 철회 신청 후 철회대기 상태로 돌입. 이 철회 대기상태의 클레임을 승인하는 요청
  */
  onWithdrawApprove(): void{
    if(!confirm(this.$t('CLAIM_POPUP_ASK_EXCHANGE_WITHDRAW_APPROVE').toString())){
      return
    }

    const request = {
      pathParams: {
        no: this.claimNo
      }
    }

    this.$api.putReturnExchangesNoApproveWithdraw(request)
      .then(()=>{
        alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
        this.onClickClose()
        this.reload()
      })
  }

  //현금 환불처리
  onRefund(): void{
    if (!confirm(this.$t('CLAIM_POPUP_ASK_REFUND_MESSAGE').toString())) {
      return;
    }

    const {refundType, refundBankAccount} = this.formData
    const request = {
      pathParams: {
        no: this.claimNo
      },
      data: {
        refundBankAccount:
          refundType === 'ACCOUNT' ?
          refundBankAccount :
          {
            bankName: null,
            depositorName: null,
            account: null,
            bank: null,
          }
      }
    }

    const refundApis = {
      [ClaimClassType.CANCEL_EXCHANGE]: () => this.$api.putCancelExchangesNoCashRefund(request),
      [ClaimClassType.RETURN_EXCHANGE]: () => this.$api.putReturnExchangesNoCashRefund(request)
    }

    refundApis[this.claimNoResponseData.claimClassType]()
      .then(()=>{
        alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
        this.onClickClose()
        this.reload()
      })
  }

  // 교환승인
  onApprove(): void{
    if (!confirm(this.$t('CLAIM_POPUP_ASK_EXCHANGE_APPROVE').toString())) {
      return;
    }

	  this.alertMessageForFreeGift();

    const {invoiceNo, deliveryCompanyType, evadesReturnProcess} = this.formData.returnDelivery
    const request = {pathParams: {no: this.claimNo}}
    const data = {
      invoiceNo: invoiceNo.length ? invoiceNo : null,
      deliveryCompanyType: deliveryCompanyType.length ? deliveryCompanyType : null,
      evadesReturnProcess
    }

    const refundApis = {
      [ClaimClassType.CANCEL_EXCHANGE]: () => this.$api.putCancelExchangesNoApprove(request),
      [ClaimClassType.RETURN_EXCHANGE]: () => this.$api.putReturnExchangesNoApprove({...request, data})
    }

    refundApis[this.claimNoResponseData.claimClassType]()
      .then(()=>{
        alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
        this.reload()
        this.onClickClose()
      })
  }

	private alertMessageForFreeGift() {

		const hasTargetProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any ).isGivenFreeGift);
		if (hasTargetProduct) {
			alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
			return;
		}

		const hasFreeGiftProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any).isFreeGift);
		if (hasFreeGiftProduct) {
			alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
		}
	}

  // 수거완료 처리
  private onCompleteCollection(): void {
    ncpPopup(
        `/claim/collectReturnPopup?claimNo=${this.$route.query.claimNo}&callback=closeProcess`,
        window.$t('CLAIM_COLUMNS_PROC_COLLECT_COMPLETE'),
        800,
        400
    );
  }

  private closeProcess(): void {
    this.onClickClose();
    this.reload();
  }

  private validation(type: 'deposit'): boolean{
    switch (type){
      case 'deposit':
        if(this.formData.additionalPayRemitter.trim().length === 0){
          alert(this.$t('CLAIM_POPUP_ADDITIONAL_PAY_REMITTER_VALID_MESSAGE').toString())
          return false
        }
        break;
    }

    return true
  }

  created(){
    this.initForm()
  }

  mounted() {
    (window as any).closeProcess = this.closeProcess;
  }

  initForm(): void{
    if(!this.claimNoResponseData.returnDelivery){ // 취소교환에는 returnDelivery가 없다.
      return
    }

    const {
      returnDelivery: {
        deliveryCompanyType,
        invoiceNo,
        evadesReturnProcess
      }
    } = this.claimNoResponseData

    this.formData = {
      ...this.formData,
      returnDelivery: {
        invoiceNo: invoiceNo.length ? invoiceNo : null,
        deliveryCompanyType: deliveryCompanyType.length ? deliveryCompanyType : null,
        evadesReturnProcess
      },
    }
  }

  private onNaverPayReleaseHold(){
    if(!confirm(this.$t('CLAIM_POPUP_ASK_EXCHANGE_RELEASE_HOLD').toString())){
      return false;
    }

    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
    }

    this.$api.putClaimsNoNaverPayExchangesReleaseHold(request).then(()=>{
      alert(this.$t('CLAIM_POPUP_ALERT_NAVER_PAY_PROCESS_SUCCESS'))
      location.reload()
    })
  }
}
